var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_15127)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_60_15127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1211 11.1169C20.3171 11.1169 20.4559 11.2707 20.4561 11.4294C20.4561 12.8484 20.029 14.2345 19.2344 15.4207L18.7578 14.9568C19.4302 13.8991 19.7861 12.6785 19.7861 11.4294C19.7863 11.2707 19.9251 11.1169 20.1211 11.1169Z",
    fill: "url(#paint0_linear_60_15127)",
    stroke: "url(#paint1_linear_60_15127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9033 0.825439C15.857 0.825439 18.2373 3.1625 18.2373 6.00122V11.4299C18.2373 12.2753 18.0206 13.1059 17.6162 13.8499L7.85156 4.34204C8.58042 2.25938 10.5991 0.829993 12.9033 0.825439Z",
    fill: "url(#paint2_linear_60_15127)",
    stroke: "url(#paint3_linear_60_15127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41309 7.88965L7.26172 7.74219L1.34082 1.98242C1.21813 1.85639 1.22127 1.66897 1.33789 1.55078C1.47185 1.42 1.68976 1.4208 1.81836 1.54102V1.54199L24.1582 23.293C24.278 23.4096 24.2826 23.6022 24.1582 23.7275C24.0409 23.8416 23.8614 23.856 23.7285 23.7705L23.6748 23.7275L17.832 18.0342L17.5332 17.7432L17.1934 17.9844C16.1207 18.7463 14.8575 19.2186 13.5361 19.3516L13.0859 19.3965V23.501C13.0859 23.6598 12.947 23.8145 12.751 23.8145C12.555 23.8144 12.416 23.6597 12.416 23.501V19.3926L11.9668 19.3467C8.1599 18.9605 5.20466 15.8306 5.19922 12.0605C5.20276 11.9066 5.33629 11.7599 5.52539 11.7559C5.69933 11.7524 5.82916 11.8682 5.86133 12.002L5.86914 12.0605C5.87493 15.7686 8.96933 18.7596 12.7461 18.7598C14.0982 18.7598 15.4218 18.3714 16.5498 17.6377L17.0742 17.2969L16.626 16.8604L16.2324 16.4766L15.9521 16.2031L15.6191 16.4111C14.7611 16.9458 13.7644 17.2295 12.7461 17.2295C9.78815 17.2247 7.41758 14.898 7.41309 12.0498V7.88965Z",
    fill: "url(#paint4_linear_60_15127)",
    stroke: "url(#paint5_linear_60_15127)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_15127",
    x1: 18.4864,
    y1: 10.7666,
    x2: 25.5252,
    y2: 17.6363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A464F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326923,
    stopColor: "#A109DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701923,
    stopColor: "#1E31DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999382,
    stopColor: "#441B6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60_15127",
    x1: 18.4505,
    y1: 10.6169,
    x2: 22.6301,
    y2: 12.5358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9747FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E31DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_60_15127",
    x1: 8.79858,
    y1: 0.710478,
    x2: 25.4026,
    y2: 26.0626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A464F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326923,
    stopColor: "#A109DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701923,
    stopColor: "#1E31DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999382,
    stopColor: "#441B6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_60_15127",
    x1: 8.654,
    y1: 0.325439,
    x2: 22.0902,
    y2: 9.97569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9747FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E31DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_60_15127",
    x1: 3.92876,
    y1: 1.58068,
    x2: 27.8716,
    y2: 48.4978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A464F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326923,
    stopColor: "#A109DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701923,
    stopColor: "#1E31DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999382,
    stopColor: "#441B6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_60_15127",
    x1: 3.62586,
    y1: 0.952148,
    x2: 26.6945,
    y2: 22.2159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9747FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E31DD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_15127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_60_15127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/mic_off.b85a9f39ac46a5c0683cf0066019f554.svg";
export { ForwardRef as ReactComponent };